const COACH_WELCOME_PRODUCT_TYPE_URI_PARAMETER_NAME = "product_type"
const COACH_WELCOME_EMAIL_URI_PARAMETER_NAME = "origin"
const COACH_WELCOME_EMAIL_URI_PARAMETER_VALUE = "email"
const COACH_WELCOME_USER_ID_URI_PARAMETER_NAME = "user_id"

export {
    COACH_WELCOME_PRODUCT_TYPE_URI_PARAMETER_NAME,
    COACH_WELCOME_EMAIL_URI_PARAMETER_NAME,
    COACH_WELCOME_EMAIL_URI_PARAMETER_VALUE,
    COACH_WELCOME_USER_ID_URI_PARAMETER_NAME
}
